const BLANK_PLAYER = { id: 0, name: '', position: '', age: '', club: { id: 0, name: '' } };

// The comparison Alpine object and other associated constants
window.appComparison = () => {
    return {

        players: {}, // player details who will be compared
        activePlayer: 0, // which player to search for

        comparison: {
            activeTab: 'radar', //status of the active tab
            active: false, //status of the compare popout
            match: 0, //the comparison results, a percentage match
            results: [], //the comparison results, an array of 9 stats: name, value1, value2
            // for anonymous mode
            revealed: false, // whether or not the results have been revealed or not
            playersMap: [0,1], // randomises the players and stores which is which
            graphColors: [ '#57d8ff', '#ba34f6' ] // colours for the graph lines
        },

        search: {
            active: false, //status of the search popout
            query: '', //text query for the search popout
            results: [], //player name search results
            focused: 0, //focused row
        },
        filters: {}, // the search player name filters
        leagues: [], // a list of leagues to filter by
        clubs: [], // a list of clubs to filter by
        searchResultsLoading: false,  // track whether the search results are loading or not
        clubsLoaded: false, //track if the list of clubs has loaded or not

        searches: {total: 0, spent: 0, remaining: 0},

        router: function(state) {
            /*
             * Do nothing is the state is not defined
             */
            if( typeof(state) === 'undefined') {
                return;
            }

            /*
             * if we're at the root then no need to do anything
             */
            if( state.root && state.url =='' ) {
                return;
            }

            /*
             * if the URL is nothing then close popups if one was set
             */
            if( state.url === '' ){
                popupIsActive = false;
                popup.close(true);
                this.closeComparison(true)
                return;
            }

            /*
             * player profile
             */
            let playerProfileUrl = /^player-profile\/([a-z-]+)\/(\d+)$/;
            let playerProfileMatches = state.url.match(playerProfileUrl);
            if( playerProfileMatches && playerProfileMatches.length === 3 ) {
                if( ! state.pushed ) {
                    playerProfile.load({ id: playerProfileMatches[2], name: playerProfileMatches[1] }, true)
                }
                return;
            }

            /*
             * player comparison
             */
            let comparisonUrl = /^compare\/([a-z-]+)\/([a-z-]+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)$/;
            let comparisonMatches = state.url.match(comparisonUrl);
            if( comparisonMatches && comparisonMatches.length === 7 ) {
                // if we came from a popup then do nothing else
                if( popupIsActive === true ) {
                    popupIsActive = false;
                    popup.close(true);
                    return;
                }

                // loading screen on as this will take a moment
                $c('appMain').loading = true;

                //set the seasons, labels will be set when seasons are loaded via ajax
                this.$store.season1Id = comparisonMatches[5]; // season 1 id
                this.$store.season2Id = comparisonMatches[6]; // season 1 id

                // set players
                axios.all([
                    axios.get('/api/player/' + comparisonMatches[3]),
                    axios.get('/api/player/' + comparisonMatches[4]),
                ])
                    .then(
                        axios.spread((...responses) => {
                            this.activePlayer = 1;
                            this.setPlayer(responses[0].data, true);
                            this.activePlayer = 2;
                            this.setPlayer(responses[1].data, true);
                            $c('appMain').loading = false;
                        })
                    )
                    .catch( ajaxFail )
            }

            /*
             * results popout
             */
            let resultsUrl = /^results\/([a-z-]+)\/([a-z-]+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/([\d,]+)$/;
            let resultsMatches = state.url.match(resultsUrl);
            if( resultsMatches && resultsMatches.length === 8 ) {

                // if we came from a popup then do nothing else
                if( popupIsActive === true ) {
                    popupIsActive = false;
                    popup.close(true);
                    return;
                }

                // if we have just carried out a search then do nothing else
                if( state.pushed ) {
                    return;
                }

                // loading screen on as this will take a moment
                $c('appMain').loading = true;

                //set the seasons, labels will be set when seasons are loaded via ajax
                this.$store.season1Id = resultsMatches[5];
                this.$store.season2Id = resultsMatches[6];

                // set the stats and set initial labels
                let stats = resultsMatches[7].split(',');
                this.$store.stats = stats;
                this.$store.totalStats = stats.length;

                // set players
                axios.all([
                    axios.get('/api/player/' + resultsMatches[3]),
                    axios.get('/api/player/' + resultsMatches[4]),
                ])
                    .then(
                        axios.spread((...responses) => {
                            this.activePlayer = 1;
                            this.setPlayer(responses[0].data, true);
                            this.activePlayer = 2;
                            this.setPlayer(responses[1].data, true);
                            this.loadComparison();
                        })
                    )
                    .catch( ajaxFail )
            }
        },

        init: function() {
            // get remaining searches for standard mode
            if( standard() ) {
                this.updateRemainingSearches();
            }

            // initialise the players - can't clone a blank object else Alpine won't watch it
            this.players[1] = { id: 0, name: '', age: '', position: '', club: { id: 0, name: '' } };
            this.players[2] = { id: 0, name: '', age: '', position: '', club: { id: 0, name: '' } };

            // initialise the filters - can't clone a blank object else Alpine won't watch it
            // this will be fully reset via openSearch
            this.filters = {
                league: { active: false, id: 0, label: getLang('all_leagues') },
                club: { active: false, id: 0, label: getLang('all_clubs') },
            };
            // if the club or league changes then update the player search results
            this.$watch( "filters.league.id", () => this.getPlayers());
            this.$watch( "filters.club.id", () => this.getPlayers());

            // reset the global filters
            this.$store.season1Id = 0;
            this.$store.season2Id = 0;
            this.$store.stats = [];
            this.$store.totalStats = 0;

            // basic routing for this page
            Spruce.watch('history', state => this.router(state));

            // update graph colours for anonymous mode
            if( pro() || elite() ) {
                Spruce.watch('anonymous', () => this.updateGraphColors());
                this.$watch('comparison.revealed', state => this.updateGraphColors());
                this.$nextTick( () => this.updateGraphColors() );
            }
        },

        /*
         * In standard mode, there is a limit to the number of searches per day
         * this gets an update from the API of these for this user
         */
        updateRemainingSearches: function() {
            axios.get('/api/searches/').then( response => {
                this.searches.total = response.data.searches_total;
                this.searches.spent = response.data.searches_spent;
                this.searches.remaining = this.searches.total - this.searches.spent;
                if(this.searches.remaining < 0) this.searches.remaining = 0;
            });
        },

        /*
         * When a player is added, a popout appears with the option to search for
         * players by name, also a league and club can be optionally set which will
         * filter these results. This function opens the popout and preloads the
         * list of leagues
         */
        openSearch: function(activePlayer) {
            // set the player to search for and set
            this.activePlayer = activePlayer;

            // Show the loading notice and cover the add player panel
            this.$store.loading = true;
            this.$store.cover = true;

            // Get the list of leagues
            axios.get('/api/leagues/')
                .then( response => {
                    // Save the player results
                    this.leagues = Object.create( response.data );

                    // add in All leagues
                    //this.leagues.unshift({ id: 0, name: getLang('all_leagues'), countryId: 0, countryName: '' });

                    // Hide the loading notice and open the search popout
                    this.$store.loading = false;
                    this.search.active = true;

                    // reset the search query (this doesn't always trigger from closeSearch)
                    this.search.results = [];

                    // Focus the query input
                    this.$nextTick( () => this.$refs.searchQuery.focus() );

                })
                .catch( response => {
                    modal(getLang('generic_error'));

                    // Hide the loading notice
                    this.$store.loading = false;
                })

            //stop document scrolling
            document.querySelector('html').classList.add('overflow-hidden');
        },

        /*
         * Close the player search popout and tidy up, including resetting the
         * search filters and the search query.
         *
         * This is triggered either by a click to the popout's close button,
         * or when a row is clicked.
         */
        closeSearch: function(fromSetPlayer) {
            // Close the search popout
            this.search.active = false;

            if( fromSetPlayer !== true ) {
                // reset the player to search for and set
                this.activePlayer = 0;

                // hide the add player panel cover
                this.search.active = false;
                this.$store.cover = false;
            }

            // Re-enable document scrolling
            document.querySelector('html').classList.remove('overflow-hidden');

            // reset the search query
            this.search.query = '';

            // reset the search results
            this.search.results = [];

            // Reset the search filters
            this.filters.league.active = false;
            this.filters.league.id = 0;
            this.filters.league.label = getLang('all_leagues');
            this.filters.club.active = false;
            this.filters.club.id = 0;
            this.filters.club.label = getLang('all_clubs');
        },

        /*
         * This sets the league to filter players with.
         *
         * This is triggered by clicking a row on the list of leagues.
         */
        setFilterLeague: function(league) {
            // Set the league name and ID
            this.filters.league.id = league.id;
            this.filters.league.label = league.name;

            // Hide the list of leagues
            this.filters.league.active = false;

            // Reset the club list's label
            this.filters.club.label = getLang('all_clubs');
            //this.filters.club.label = 'All ' + league.name + ' clubs';

            // Set a flag that the clubs haven't been loaded, this is used to determine
            // whether or not the clubs filter dropdown is disabled or not
            this.clubsLoaded = false;

            // Load the list of clubs for this league
            if( league.id != 0 ) {
                axios.get('/api/clubs/' + league.id)
                .then( response => {
                    // Save the results
                    this.clubs = Object.create( response.data );

                    // Update the flag
                    this.clubsLoaded = true;

                    // show the clubs list
                    this.filters.club.active = true;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })

            }
        },

        /*
         * This sets the club to filter players with.
         *
         * This is triggered by clicking a row on the list of clubs.
         */
        setFilterClub: function(club) {
            // Set the club name and ID
            this.filters.club.id = club.id;
            this.filters.club.label = club.name;

            // Hide the list of clubs
            this.filters.club.active = false;
        },

        /*
         * This fetches a list of players via AJAX for the player search popout,
         * it uses the player name (3 characters minimum) and optional filters
         * for the league and club.
         *
         * It is triggered by the search input field with an input handler.
         *
         * It is also called by watchers for filters.league.id and filters.club.id
         */
        getPlayers: function() {
             // Show the local loading notice just for the player name list
            this.searchResultsLoading = true;

            // Fetch the players that match the query and filters
            axios.get('/api/players/' + ( this.search.query.length < 3 ? '-1' : this.search.query ), {
                params: {
                    league_id: this.filters.league.id,
                    club_id: this.filters.club.id,
                    position_id: this.hasAtLeastOnePlayer() ? ( this.hasGoalkeeper() ? 'Goalkeeper' : 'Outfield' ) : -1
                }
            })
                .then( response => {
                    // Save the player results
                    this.search.results = Object.create( response.data );

                    // Hide the local loading notice
                    this.searchResultsLoading = false;

                    // Focus the first row
                    //this.search.focused = 0;

                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        /*
         * Utility function: checks if either player has been set.
         */
        hasAtLeastOnePlayer: function() {
            return this.players[1].id || this.players[2].id;
        },

        /*
         * Utility function: checks if either player is a goalkeeper.
         */
        hasGoalkeeper: function() {
            return this.players[1].position == 'GK' || this.players[2].position == 'GK';
        },

        /*
         * Sets the active player.
         *
         * This is triggered either when a row is clicked.
         */
        setPlayer: function(player, fromRouter) {
            // Check we aren't trying to compare a goalkeeper with an active player
            if(
                this.hasAtLeastOnePlayer() && (
                    (this.hasGoalkeeper() && player.position != 'GK') ||
                    (! this.hasGoalkeeper() && player.position == 'GK')
                )
            ) {
                modal(getLang('comparison_error'));
                if( fromRouter === true ) {
                    location.href = location.href.replace(location.hash, '');
                }
                return;
            }

            if( fromRouter !== true ) {
                // close the search
                this.closeSearch(true);

                // Show the loading notice as the seasons will need to load
                this.$store.loading = true;

                // Reset the global filters and update the label in the select box component for this player only
                if( this.activePlayer == 1 ) {
                    this.$store.season1Id = 0;
                    $c('selectSeason1Id').label = $c('selectSeason1Id').initialLabel;
                } else if( this.activePlayer == 2 ) {
                    this.$store.season2Id = 0;
                    $c('selectSeason2Id').label = $c('selectSeason2Id').initialLabel;
                }
            }

             // Set the player's details
            this.players[this.activePlayer] = {
                id: player.id,
                name: player.name,
                position: player.position,
                positionTranslated: player.positionTranslated,
                age: player.age,
                club: { id: player.club.id, name: player.club.name },
            };

            // Optional: do not reset the stats, as it's handy to keep these and swap players out
            // uncomment the following two lines to reset the stats
            //this.$store.stats = [];
            //window.dispatchEvent(new CustomEvent('clear-all'));

            // Load in the seasons for this player
            let seasonComponentId = 'selectSeason' + this.activePlayer + 'Id';
            let seasonStoreId = 'season' + this.activePlayer + 'Id';
            axios.get('/api/seasons/' + this.players[this.activePlayer].id)
                .then( response => {

                    // Update the relevant season's select box component's item list
                    $c(seasonComponentId).items = Object.create( response.data );

                    // Hide the loading notice and add player panel cover
                    this.$store.loading = false;
                    this.$store.cover = false;

                    // if the season IDs are already set, then set the labels
                    this.$nextTick( () => {
                        if( this.$store[seasonStoreId] ) {
                            $c(seasonComponentId).label =
                                $c(seasonComponentId).items[
                                    $c(seasonComponentId).items.findIndex(i => i.value == this.$store[seasonStoreId])
                                ].label;
                        }
                    });

                })
                .catch( response => {
                    modal(getLang('generic_error'));

                    // Remove the current player, and hide the loading notice and cover
                    this.removePlayer(this.activePlayer);
                    this.$store.loading = false;
                    this.$store.cover = false;
                });

        },

        /*
         * Removes the active player and starts the process again.
         *
         * This is triggered by the close button on a player's card.
         */
        removePlayer: function(i) {
            // Clear the player's details
            this.players[i] = Object.create( BLANK_PLAYER );

            // Hide the compare popout
            this.closeComparison();
        },

        /*
         * Once both players have been selected, along with 2 seasons, and exactly 9 stats,
         * load the comparison of players into a popout.
         *
         * This is triggered by the Compare button.
         */
        loadComparison: function() {
            // Sanity check, ensure all exactly 2 players, 2 seasons and 8 stats are set
            if( ! this.players[1].id || ! this.players[2].id || ! this.$store.season1Id || ! this.$store.season2Id || this.$store.stats.length != 8 ) {
                return;
            }

            // Show the loading notice
            this.$store.loading = true;

            if( pro() || elite() ) {

                // randomise players for anonymous mode
                if( this.$store.anonymous ) {
                    // if we are already in anonymous mode then randomise...
                    this.randomisePlayers();
                } else {
                    // otherwise set the map to be Player A => Player 1 and Player B => Player 2
                    this.comparison.playersMap = [ 0, 1 ];
                }

                // reset the anonymous revealed state
                this.comparison.revealed = false;

                // initialise the save comparison component
                window.dispatchEvent(new CustomEvent('init-save-comparison'));
            }

            //clear the radar graph HTML
            document.getElementById('graph-radar').innerHTML = '';
            if( pro() || elite() ) {
                document.getElementById('graph-table').innerHTML = '';
            }

            //reset the comparison stats and percentage
            this.comparison.results = [];
            this.comparison.match = 0;
            this.comparison.activeTab = 'radar';

            // Load comparison results (not yet the match, as this takes longer to calculate), passing the player IDs, seasons and stats
            const params =
                this.players[1].id + '/' + this.$store.season1Id + '/' +
                this.players[2].id + '/' + this.$store.season2Id;
                axios.get('/api/comparison/graphs/' + params + '/' + this.$store.stats.join(','))
                    .then( response => {
                        // add the graph and table (if pro)
                        document.getElementById('graph-radar').innerHTML = response.data.radar;
                        if( pro() || elite() ) {
                            document.getElementById('graph-table').innerHTML = response.data.table;
                        }

                        // Hide the loading notices
                        this.$store.loading = false;
                        $c('appMain').loading = false;

                        // Show the results popout
                        this.openComparison();

                        // Scroll to results, needed for mobile view where these are below the main panel
                        this.$nextTick( () => {
                            document.querySelector('#results').scrollIntoView({ behavior: 'smooth', block: 'start' });
                            document.querySelector('#results').style.display = 'flex'; // hack for safari 14 rendering bug
                        });

                        // Fetch the match percentage
                        axios.get('/api/comparison/match/' + params + '/' + this.$store.stats.join(','))
                            .then( response => {
                                this.comparison.match = response.data;
                            })
                            .catch( response => {
                                modal(getLang('generic_error'));
                            })

                        // track global filters and hide popout if anything changes
                        if( ! this.filterWatchersSet ) {
                            this.filterWatchersSet = true;
                            Spruce.watch('season1Id', () => this.closeComparison());
                            Spruce.watch('season2Id', () => this.closeComparison());
                            Spruce.watch('totalStats', () => this.closeComparison());
                        }

                        // Add this state to history
                        let path = buildPath([
                            'results',
                            stringToSlug( this.players[1].name ),
                            stringToSlug( this.players[2].name ),
                            this.players[1].id,
                            this.players[2].id,
                            this.$store.season1Id,
                            this.$store.season2Id,
                            this.$store.stats.join(','),
                        ]);

                        // only push to history if this is different, else replace
                        if( path != this.$store.history.url ) {
                            historyManager.push(path, {});
                        } else {
                            historyManager.replace(path, {});
                        }

                        // update the searches
                        if( standard() ) {
                            this.updateRemainingSearches();
                        }
                    })
                    .catch( response => {
                        modal(getLang('generic_error'));

                        // Hide the loading notice
                        this.$store.loading = false;
                    })
        },

        /*
         * Open the compare players popout.
         *
         * This is triggered by watchers for any changes on the global filters, and the
         * removePlayer function.
         */
        openComparison: function() {
            this.comparison.active = true;
        },

        /*
         * Close the compare players popout.
         *
         * This is triggered by watchers for any changes on the global filters, and the
         * removePlayer function.
         */
        closeComparison: function(fromRouter) {
            //close the results popout
            this.comparison.active = false;

            //reset the history state
            if( ! fromRouter ) {
                historyManager.reset();
            }
        },

        /*
         * Utility function, this randomises the players for anonymous mode.
         *
         * This is triggered by the loadComparison function.
         */
        randomisePlayers: function() {
            const a = Math.floor(Math.random() * 2 );
            const b = a === 0 ? 1 : 0;
            this.comparison.playersMap = [ a, b ];
            this.updateGraphColors();
        },

        /*
         * Utility function, this updates the CSS vars for graph colours.
         *
         * This is triggered by a watcher for $store.anonymous
         */
        updateGraphColors: function() {
            if( this.comparison.playersMap.length !== 2 ) {
                return;
            }
            document.documentElement.style.setProperty('--player-a', this.$store.anonymous && ! this.comparison.revealed
                ? this.comparison.graphColors[this.comparison.playersMap[0]]
                : ''
            );
            document.documentElement.style.setProperty('--player-b', this.$store.anonymous && ! this.comparison.revealed
                ? this.comparison.graphColors[this.comparison.playersMap[1]]
                : ''
            );
        }

    }
};
